import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
  Button,
} from "@mui/material";
import { GitHub, Launch } from "@mui/icons-material";
import styled from "styled-components";
import "@fontsource/raleway";
import AOS from "aos";
import "aos/dist/aos.css";
import { ShakeSlow } from "reshake";
import "@fontsource/raleway";
import "@fontsource/great-vibes";

const OpenPDFNew = (url) => {
  window.open(url, "_blank");
};

function ProjectCard({
  title,
  description,
  imageUrl,
  githubLink,
  demoLink,
  tech_stack,
}) {
  return (
    <Main className="project-card">
      <Card
        sx={{ maxWidth: 345 }}
        style={{
          boxShadow:
            "rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px",
          marginTop: "1.5%",
        }}
      >
        <CardMedia component="img" height="140" image={imageUrl} alt={title} />
        <CardContent>
          <Typography
            gutterBottom
            variant="h5"
            component="div"
            fontFamily={"Great vibes"}
            className="project-title"
          >
            {title}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            fontFamily={"Raleway"}
            className="project-description"
          >
            {description}
          </Typography>
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              margin: "auto",
              marginTop: "1.5rem",
            }}
          >
            {tech_stack.map((el) => {
              return (
                <Main>
                  <CardMedia
                    component="img"
                    style={{ height: "30px", width: "30px" }}
                    image={el.url}
                    alt={tech_stack}
                    align="center"
                  />
                  <Typography
                    variant="caption"
                    align="center"
                    fontFamily={"Raleway"}
                    className="project-tech-stack"
                  >
                    {" "}
                    {el.name}
                  </Typography>
                </Main>
              );
            })}
          </div>
          <Grid container spacing={2} mt={2}>
            <Grid item xs={6}>
              <Button
                fullWidth
                variant="contained"
                startIcon={<GitHub />}
                target="_blank"
                style={{ backgroundColor: "rgba(28, 28, 28, 0.911)" }}
                className="project-github-link"
                onClick={() => OpenPDFNew(githubLink)}
              >
                GitHub
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                className="my-typography-button project-deployed-link"
                variant="contained"
                style={{
                  backgroundColor: "rgb(255, 255, 255)",
                  color: "black",
                  margin: "2%",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#04c984")
                }
                onMouseLeave={(e) => (e.target.style.backgroundColor = "#fff")}
                size="medium"
                startIcon={<Launch />}
                onClick={() => OpenPDFNew(demoLink)}
              >
                Demo
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Main>
  );
}
function Projects() {
  const projects = [
    {
      title: "TagShop.com",
      description:
        "This was a individual project.I have created this e commerce retail website with the help of HTML, CSS And Javascript.",
      tech_stack: [
        {
          url: "https://cdn-icons-png.flaticon.com/512/732/732212.png",
          name: "html",
        },
        {
          url: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/CSS3_logo.svg/800px-CSS3_logo.svg.png",
          name: "css",
        },
        {
          url: "https://icon-library.com/images/javascript-icon-png/javascript-icon-png-23.jpg",
          name: "js",
        },
      ],
      imageUrl: "./TagShop.jpg",
      githubLink: "https://github.com/Tathagat017/TagShop",
      demoLink: "https://playful-pegasus-8b5758.netlify.app",
    },
    {
      title: "ShopJio.com",
      description:
        " This was an group project created by a team of 5 in span of 3 days.The website, Ajio.com ,is an online e-commerce platform apparel retail .",
      tech_stack: [
        {
          url: "https://cdn-icons-png.flaticon.com/512/732/732212.png",
          name: "html",
        },
        {
          url: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/CSS3_logo.svg/800px-CSS3_logo.svg.png",
          name: "css",
        },
        {
          url: "https://icon-library.com/images/javascript-icon-png/javascript-icon-png-23.jpg",
          name: "js",
        },
      ],
      imageUrl: "./shopjio.jpg",
      githubLink: "https://github.com/Tathagat017/ShopJio-Project",
      demoLink: "https://heartfelt-kheer-167feb.netlify.app/",
    },
    {
      title: "TownHouse.com",
      description:
        "This was a individual project.I have created this e commerce exotic handricrafts retail website with the help of HTML, CSS ,Javascript,React",
      tech_stack: [
        {
          url: "https://cdn-icons-png.flaticon.com/512/732/732212.png",
          name: "html",
        },
        {
          url: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/CSS3_logo.svg/800px-CSS3_logo.svg.png",
          name: "css",
        },
        {
          url: "https://icon-library.com/images/javascript-icon-png/javascript-icon-png-23.jpg",
          name: "js",
        },

        {
          url: "https://cdn.iconscout.com/icon/free/png-256/react-1-282599.png?f=webp&w=256",
          name: "React",
        },
      ],
      imageUrl: "./townhouse.jpg",
      githubLink:
        "https://github.com/Tathagat017/TownHouse_A-Craftvilla_Clone.git",
      demoLink: "https://rct101prjecttathagat.netlify.app/",
    },
    {
      title: "Manyata.com",
      imageUrl: "./Manyata.jpg",
      description:
        "This was a individual project.I have created this e commerce exotic handricrafts retail website with the help of HTML, CSS ,Javascript,React",
      tech_stack: [
        {
          url: "https://cdn-icons-png.flaticon.com/512/732/732212.png",
          name: "html",
        },
        {
          url: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/CSS3_logo.svg/800px-CSS3_logo.svg.png",
          name: "css",
        },
        {
          url: "https://icon-library.com/images/javascript-icon-png/javascript-icon-png-23.jpg",
          name: "js",
        },

        {
          url: "https://cdn.iconscout.com/icon/free/png-256/react-1-282599.png?f=webp&w=256",
          name: "React",
        },
      ],
      githubLink: "https://github.com/Tathagat017/Manyata_Clone.git",
      demoLink: "https://effortless-pasca-3465fc.netlify.app/",
    },
  ];
  useEffect(() => {
    AOS.init({
      duration: 1200,
    });
    AOS.refresh();
  }, []);
  return (
    <BOX data-aos="fade-left" id="projects" className="nav-link projects">
      <Typography
        variant="h4"
        color="black"
        style={{ fontFamily: "Great Vibes", color: "#1b242f" }}
      >
        Projects
      </Typography>
      <div
        style={{
          width: "3rem",
          backgroundColor: "#1b242f",
          height: "1vh",
          margin: "auto",
          marginBottom: "2%",
        }}
        data-aos="fade-left"
      ></div>
      <Grid container spacing={3} data-aos="fade-up">
        {projects.map((project, index) => (
          <Grid item key={index} xs={12} sm={6} md={4}>
            <ProjectCard {...project} />
          </Grid>
        ))}
      </Grid>
    </BOX>
  );
}
const BOX = styled.div`
  text-align: center;
  margin: auto;
  width: 88%;
`;

const Main = styled.div`
  :hover {
    cursor: pointer;
    transform: scale(1.08);
  }
`;

export default Projects;
